import { bridge } from "@multiweb/reactCore/bridge";
import { isEmptyString, isNull, isUndefined } from "./type";

const { decimalSeparator } = bridge;

export const INTEGER_REGEX = new RegExp("^-?[0-9]+$");
export const INTEGER_REGEX_WHITELIST: string[] = ["0-9", "-"];

export const FLOAT_REGEX = new RegExp(`^-?[0-9]+(${decimalSeparator}[0-9]+)?$`);
export const FLOAT_REGEX_WHITELIST: string[] = ["-", "0-9", decimalSeparator];

export const empty = (value: any): boolean => isNull(value) || isUndefined(value) || isEmptyString(value);

export const required = (value: any): boolean => !empty(value);

export const createMin = (minValue: number) => (value: number) => min(minValue, value);

const min = (minValue: number, value: number): boolean => value >= minValue;

export const createMax = (maxValue: number) => (value: number) => max(maxValue, value);

const max = (maxValue: number, value: number): boolean => value <= maxValue;

export const createMaxLength = (length: number) => (value: string) => maxLength(length, value);

/**
 * @param length {number} Maximální délka řetězce
 * @param value {string|number} Hodnota pro kontrolu maximální délky řetězce
 **/
const maxLength = (length: number, value: string | number): boolean => (
    empty(value) || value.toString().length <= length
);

export const createMinLength = (length: number) => (value: string | number) => minLength(length, value);

/**
 * @param length {number} Minimální délka řetězce
 * @param value {string} Hodnota pro kontrolu minimální délky řetězce
 **/
const minLength = (length: number, value: string | number): boolean => (
    !empty(value) && value.toString().length >= length
);

/**
 * @param value {string} Hodnota pro kontrolu řetězce na splnění požadavků na celé číslo
 **/
export const integer = (value: string | number): boolean => (
    !!value && value.toString && INTEGER_REGEX.test(value.toString())
);

/**
 * @param value {string} Hodnota pro kontrolu řetězce na splnění požadavků na desetinné číslo
 **/
export const float = (value: string): boolean => (
    !!value && value.toString && FLOAT_REGEX.test(value.toString())
);
